import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Typography, withStyles } from '@material-ui/core';

const styles = () => ({
  root: {},
});

function Price({ classes, className, item, settings }) {
  if (!item) return null;

  const currency = get(item, 'currency', 'EUR');
  const salePrice = get(item, 'salePrice');

  const monopolyUrl = get(item, 'monopoly_url');

  return (
    <Typography className={clsx(classes.root, className)}>
      {get(settings, 'klevu_showPrices') && salePrice && monopolyUrl && (
        <strong>
          {new Intl.NumberFormat('fi-FI', {
            style: 'currency',
            currency,
          }).format(parseFloat(salePrice))}
        </strong>
      )}
    </Typography>
  );
}

Price.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  item: PropTypes.object,
  settings: PropTypes.object,
};

Price.defaultProps = {
  classes: {},
  className: null,
  item: {
    currency: '',
    salePrice: '',
  },
  settings: {},
};

export default withStyles(styles)(Price);
